import React from 'react';
import { useQuery } from 'react-query';
import { SingleValue } from 'react-select';
import api from '../../../../components/api';

function useRoutesClient(client: number | string, formik: any, clients?: number[], isNew?: boolean) {
  /* handler show and hide of client component */
  const [show, setShow] = React.useState<boolean>(true);
  const handleShow = () => setShow(!show);

  /* state management of time range picker */
  const [chosenTime, setChosenTime] = React.useState({
    startTime: '00.00 AM',
    endTime: '00.00 AM',
  });

  const timeConverter = (e: Date) => e.toString().split(' ')[4].substring(0, 5);

  const handleChangeStart = (e:Date|null) => {
    if (e) {
      const time = timeConverter(e);
      if (parseInt(time, 10) >= 13) {
        setChosenTime({ ...chosenTime, startTime: `${time} PM` });
      } else {
        setChosenTime({ ...chosenTime, startTime: `${time} PM` });
      }
    }
  };

  const handleChangeEnd = (e:Date|null) => {
    if (e) {
      const time = timeConverter(e);
      if (parseInt(time, 10) >= 13) {
        setChosenTime({ ...chosenTime, endTime: `${time} PM` });
      } else {
        setChosenTime({ ...chosenTime, endTime: `${time} PM` });
      }
    }
  };

  /* list of clients for form select */
  const { isLoading, data, error } = useQuery(
    ['getAllActive', 'clients'],
    () => api.clients.getAllActive(),
  );

  /* Selected Client */
  const [selectedClient, setSelectedClient] = React.useState<any>(undefined);

  const clientList = React.useMemo(() => {
    if (data && clients) {
      return data.data.data.map((resultData: {name: string, id: number, vendingMachines: any, lng: any, lat: any, address: any}) => {
        const address = `${resultData.address.streetAddress}, ${resultData.address.city}, ${resultData.address.state}, ${resultData.address.zipCode}`;
        const {
          name, id, vendingMachines, lng, lat,
        } = resultData;
        return {
          label: name,
          value: id,
          address,
          vendingMachines,
          position: {
            lng, lat,
          },
          isDisabled: clients.includes(id) || (!isNew) || lng === null || lat === null,
        };
      });
    }
    return [];
  }, [data, clients]);

  React.useEffect(() => {
    if (client && clientList && !selectedClient) {
      const findClient = clientList.find((x: any) => x.value.toString() === client.toString());
      if (findClient) setSelectedClient(findClient);
    }
  }, [client, clientList]);

  const handleChangeClient = (e: SingleValue<any>, index: number) => {
    const currentArray: number[] = formik.values.clients;
    currentArray[index] = e.value;
    // formik.setFieldValue('clients', [...currentArray]);
    setSelectedClient(e);
  };

  return {
    chosenTime,
    handleChangeStart,
    handleChangeEnd,
    isLoading,
    clientList,
    error,
    handleShow,
    show,
    selectedClient,
    handleChangeClient,
  };
}

export default useRoutesClient;
